import * as React from 'react';

function RemoteUnlockIcon({ color = '#545454', ...props }) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M10.416 14.141v-2.857a3.572 3.572 0 017.071-.714m-8.5 3.571h10c.79 0 1.429.64 1.429 1.429v5c0 .79-.64 1.429-1.429 1.429h-10c-.789 0-1.428-.64-1.428-1.429v-5c0-.789.64-1.429 1.428-1.429zM8.975 5.87a6 6 0 00-2.317 3.965m-.102-7.15a10 10 0 00-3.86 6.608'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default RemoteUnlockIcon;
